import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { HttpClient } from '@angular/common/http';
import { IPaginatedResponse } from '@boma/administration-portal/shared/entities';
import { IBrand, IBrandAdd, IBrandResponse } from '@boma/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  getAllBrandsUsedInMyCatalogue(entityId: string) {
    return this.httpClient.get<IBrandResponse[]>(
      `${this.base}api/v${this.version}/${entityId}/Brands/All`
    );
  }

  listBrands(
    entityId: string,
    query: string = '',
    page: string = '1',
    perPage: string = '25'
  ) {
    return this.httpClient.get<IPaginatedResponse<IBrandResponse>>(
      `${this.base}api/v${this.version}/${entityId}/Brands`,
      {
        params: { page, perPage, query },
      }
    );
  }

  getBrandDetails(id: string, entityId: string) {
    return this.httpClient.get<IBrandResponse>(
      `${this.base}api/v${this.version}/${entityId}/Brands/${id}`
    );
  }

  uploadBrandImage(file: File, entityId: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/${entityId}/Brands/UploadImage`,
      formData
    );
  }

  createBrand(brand: IBrandAdd, entityId: string) {
    return this.httpClient.post<IBrand>(
      `${this.base}api/v${this.version}/${entityId}/Brands`,
      {
        ...brand,
      }
    );
  }

  updateBrand(brand: any, brandId: string, entityId: string) {
    return this.httpClient.put<IBrand>(
      `${this.base}api/v${this.version}/${entityId}/Brands/${brandId}`,
      {
        ...brand,
      }
    );
  }
}
